import { render, staticRenderFns } from "./CardGroups.vue?vue&type=template&id=a416a54c"
import script from "./CardGroups.vue?vue&type=script&lang=js"
export * from "./CardGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports